import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PostsService } from '../posts.service';
import { DomSanitizer, Title }     from '@angular/platform-browser';
import * as PrismicDOM from 'prismic-dom';
import * as _ from 'lodash'; 

@Component({
  selector: 'app-dude',
  templateUrl: './dude.component.html',
  styleUrls: ['./dude.component.css']
})
export class DudeComponent implements OnInit {
  
  public post;
  public loading:boolean;

  private getPost(): void {
    const id = this.route.snapshot.paramMap.get('id');
    this.posts.getPost('team', id).subscribe((post)=>{
      this.post = post;
      this.loading = false;
    });
  }

  generateMarkup(data){
    return PrismicDOM.RichText.asHtml(data);
  }

  constructor(private route: ActivatedRoute, private sanitizer:DomSanitizer, private posts:PostsService, private titleService: Title) { }

  ngOnInit() {
    this.loading = true;
    this.getPost();
    this.titleService.setTitle("Team -- Bender Hardware");

  }

}



// WEBPACK FOOTER //
// /tmp/build_fdb7fa8d/src/app/dude/dude.component.ts